import { DatePipe } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  constructor() {
    const matDateLocale = inject(MAT_DATE_LOCALE, { optional: true });

    super(matDateLocale);
  }

  format(date: Date): string {
    return new DatePipe(this.locale).transform(date, 'MMMM YYYY');
  }
}
